import type { ReactElement } from 'react';
import React from 'react';
import { useLevelById } from 'services/assist-api/entities/level/levels';

export default function YearLevel({ levelId }: { levelId: number }): ReactElement {
  const level = useLevelById(levelId);
  return <>{level?.name}</>;
}
